import {
    CKYC_DATA_REQUEST,
    CKYC_DATA_ERROR,
    CKYC_DATA_SUCCESS,
    GET_INPUT_IFSC_CODE,
    FETCH_IFSC_CODE_REQUEST,
    FETCH_IFSC_CODE_SUCCESS,
    FETCH_IFSC_CODE_ERROR,
    FETCH_IFSC_CODE_RESET,
    CONNECT_FETCH_KYC_REQUEST,
    CONNECT_FETCH_KYC_SUCCESS,
    CONNECT_FETCH_KYC_ERROR,
    CKYC_CONFIRMATION_REQUEST,
    CKYC_CONFIRMATION_SUCCESS,
    CKYC_CONFIRMATION_ERROR,
    FETCH_BANK_DETAIL_ERROR,
    FETCH_BANK_DETAIL_SUCCESS,
    FETCH_BANK_DETAIL
} from "../actionType";

export const getCKycRequest = (value: any) => ({
    type: CKYC_DATA_REQUEST,
    value,
  });

export const getCKycSuccess = (data: any) => ({
    type: CKYC_DATA_SUCCESS,
    payload: data
});

export const getCKycError = (error: any) => ({
    type: CKYC_DATA_ERROR,
    payload: error
});

export const getInputIfscValue = (data: any) => ({
    type: GET_INPUT_IFSC_CODE,
    payload: data
});

export const fetchIfscReq = () => ({
    type: FETCH_IFSC_CODE_REQUEST,
});

export const getIfscReqSuccess = (data: any) => ({
    type: FETCH_IFSC_CODE_SUCCESS,
    payload: data
});

export const getIfscReqError = (error: any) => ({
    type: FETCH_IFSC_CODE_ERROR,
    payload: error
});

export const getResetIfscCode = () => ({
    type: FETCH_IFSC_CODE_RESET,
});
export const connectFetchKycReq = () => ({
    type: CONNECT_FETCH_KYC_REQUEST,
});

export const connectFetchKycSuccess = (data: any) => ({
    type: CONNECT_FETCH_KYC_SUCCESS,
    payload: data
});

export const connectFetchKycError = (error: any) => ({
    type: CONNECT_FETCH_KYC_ERROR,
    payload: error
});

export const ckycConfirmReq = () => ({
    type: CKYC_CONFIRMATION_REQUEST,
  });

export const ckycConfirmReqSuccess = (data: any) => ({
    type: CKYC_CONFIRMATION_SUCCESS,
    payload: data
});

export const ckycConfirmReqError = (error: any) => ({
    type: CKYC_CONFIRMATION_ERROR,
    payload: error
});

export const fetchBankdetailsResponse = () => ({
    type: FETCH_BANK_DETAIL
});

export const fetchBankdetailsResponseSuccess = (data:any) => ({
    type:FETCH_BANK_DETAIL_SUCCESS,
    payload:data
});

export const fetchBankdetailsResponseError = (error:any) => ({
    type:FETCH_BANK_DETAIL_ERROR,
    payload:error
});